import { Component, OnInit, ViewChild, ElementRef } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { BotRegistrationService } from "src/app/services/core/bot-registration/bot-registration.service";
import { BroadcastService } from "src/app/services/core/broadcast/broadcast.service";
import { ConfigurationSettings } from "src/app/models/configuration.settings";
import { ToasterService } from "../../../services/shared/toaster/toaster.service";
import { UtilityService } from "src/app/services/shared/utility/utility.service";
import { IBroadcast, IBroadcastBotInfo } from "src/app/models/broadcast";
import { Subscription } from "rxjs";
import { Router, ActivatedRoute } from "@angular/router";
import { MatDialog } from "@angular/material";
import { WarningPopupComponent } from "../../shared/warning-popup/warning-popup.component";
import { IUserRoleDetails } from "src/app/models/user-role-details";

@Component({
  selector: "app-broadcast",
  templateUrl: "./broadcast.component.html",
  styleUrls: ["./broadcast.component.scss"]
})
export class BroadcastComponent implements OnInit {
  @ViewChild("closebutton", { static: true }) SaveButton: ElementRef;
  addNewBroadcast: boolean;
  broadcastDetails: any;
  broadcastId: number;
  private userRoles: string[] = [];
  private userRoleDetails: IUserRoleDetails[] = [];
  private _subscriptions = new Subscription();
  constructor(
    private httpClient: HttpClient,
    private botRegistrationService: BotRegistrationService,
    private configurationSetting: ConfigurationSettings,
    private toasterService: ToasterService,
    private broadcastService: BroadcastService,
    private utilityService: UtilityService,
    private dialogWarning: MatDialog,
    private router: Router,
    private route: ActivatedRoute
  ) {}
  
  private gridColumnApi;
  private gridApi;
  botList: any;
  broadcastBotInfo: IBroadcastBotInfo;
  modalTitle = "Create New Broadcast";
  superAdmin: boolean;
  botConfigId: number;
  hideAddButton: boolean = true;
  notifyRequest: IBroadcast;
  userData: any[] = [];
  closeResult = "";
  selectedBot = "";
  sortingOrder;
  defaultColDef;
  domLayout: string;
  paginationPageSize = 100;
  rowData = [];
  columnDefs: any[] = [];
  broadcastList: IBroadcast[] = [];
  selectedOption: Number;

  ngOnInit() {
    this.selectedOption = -1;
    this.route.queryParams.subscribe((params) => {
      const res = params["id"];
      if (res) {
        this.broadcastBotInfo = JSON.parse(
          sessionStorage.getItem("broadcastBotInfo")
        );
        this.selectedBot = this.broadcastBotInfo.displayName;
        this.botConfigId = this.broadcastBotInfo.botConfigId;
        this.selectedOption = res;
        this.createRowData();
        this.hideAddButton = false;
      }
    });
    this.userRoles = sessionStorage.getItem("userRoles")
      ? sessionStorage.getItem("userRoles").split(",")
      : [];
    let superAdminUser = this.userRoles.find(
      (ob) =>
        ob.toLowerCase() === "superadmin" || ob.toLowerCase() === "super admin"
    );
    if (superAdminUser) {
      this.superAdmin = true;
    }

    //Taking accessed bot list
    this.botRegistrationService.getRegisteredBots().subscribe(
      (res) => {
        sessionStorage.setItem("lastActiveTab", "utility");
        this.botList = this.setBotList(res);
        if (this.botList.length > 0) {
          this.botConfigId = this.botList[0].botConfigId;
          // this.showTestBtn = true;
        }
      },
      (error) => {
        this.toasterService.error(
          "Unable to fetch BOT(s) details at the moment"
        );
      }
    );
  }

  setBotList(botlistResult) {
    let listOfBots = [];
    listOfBots.push({ botConfigId: -1, displayName: "-Select Bot-" });
    if (this.superAdmin) {
      botlistResult.forEach((item) => {
        listOfBots.push({
          botConfigId: item.botConfigId,
          displayName: item.displayName,
        });
      });
    } else {
      let botIds = this.utilityService.GetFeaturewiseBotList(sessionStorage.getItem('userBotRoles'),"Broadcast");
        botlistResult.forEach((item) => {
        botIds.forEach((botConfigId) => {
          if (botConfigId == item.botConfigId) {
            listOfBots.push({
              botConfigId: item.botConfigId,
              displayName: item.displayName,
            });
          }
        });
      });
    }
    return listOfBots;
  }

  onBotChange(event) {
    if (event.target.value != -1) {
      this.botConfigId = event.target.value;
      this.hideAddButton = false;
      this.selectedBot =
        event.target.options[event.target.options.selectedIndex].text;
      this.createRowData();
      this.setBotInfoSession();
    }
  }

  createColumnDefs() {
    const customComparator = (valueA, valueB) => {
      valueA = valueA ? valueA : "";
      valueB = valueB ? valueB : "";
      return valueA.toLowerCase().localeCompare(valueB.toLowerCase());
    };
    const columnDefs = [
      {
        headerName: "Survey",
        field: "name",
        width: 200,
        comparator: customComparator,
        filter: true,
        sortable: true,
        sortingOrder: ["asc", "desc"],
      },
      {
        headerName: "Description",
        field: "description",
        width: 420,
        comparator: customComparator,
        filter: false,
        sortable: false,
      },
      {
        headerName: "Trigger Mode",
        field: "triggerMode",
        width: 100,
        comparator: customComparator,
        filter: true,
        sortable: true,
        sortingOrder: ["asc", "desc"],
      },
      {
        headerName: "Created Date",
        field: "createdDate",
        width: 160,
        comparator: customComparator,
        filter: true,
        sortable: true,
        sortingOrder: ["asc", "desc"],
      },
      {
        headerName: "Status",
        field: "status",
        width: 80,
        comparator: customComparator,
        filter: true,
        sortable: true,
        sortingOrder: ["asc", "desc"],
      },

      {
        headerName: "Edit",
        width: 70,
        left: 637,
        cellRenderer: this.editBroadcastCellRenderer.bind(this),
      },
      {
        headerName: "Actions",
        width: 70,
        cellRenderer: this.broadcastActionCellRenderer.bind(this),
      },
    ];
    this.columnDefs = columnDefs;
  }

  createRowData() {
    this.rowData = [];
    this._subscriptions.add(
      this.broadcastService.GetAllBroadcasts(this.botConfigId).subscribe(
        (res) => {
          this.broadcastList = res;
          this.rowData = this.broadcastList;
          this.createColumnDefs();
        },
        (error) => {
          this.toasterService.warn("No files found");
        }
      )
    );
  }

  // openWarning(fileDetails: any) {
  //   let dialogRef = this.dialogWarning.open(WarningPopupComponent, {
  //     height: "35%",
  //     width: "35%",
  //     autoFocus: false,
  //     data: fileDetails,
  //   });
  //   dialogRef.afterClosed().subscribe((result) => {
  //     this.createRowData();
  //   });
  // }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridApi.sizeColumnsToFit();
    this.gridColumnApi = params.columnApi;
    this.gridApi.setDomLayout("autoHeight");
    this.gridApi.paginationSetPageSize(15);
  }
  broadcastActionCellRenderer(broadcastInfo: any) {
    let broadcastData = JSON.stringify(broadcastInfo.data);
    const element = document.createElement("span");
    let template =
      '<i class="fa fa-hammer" aria-hidden="true" style="cursor: pointer;"></i>';
    element.innerHTML = template;
    element.addEventListener("click", () => {
      sessionStorage.removeItem("broadcastData");
      sessionStorage.setItem("broadcastData", broadcastData);
      let allowAction = this.checkRoleForAction(this.botConfigId);
      if (allowAction) {
        this.router.navigate(["utility/broadcastactions"]);
      } else {
        this.toasterService.error(
          "You are not authorized to edit broadcast for this BOT!"
        );
      }
    });
    return element;
  }
  editBroadcastCellRenderer(broadcastInfo: any) {
    let broadcastData = JSON.stringify(broadcastInfo.data);
    const element = document.createElement("span");
    let template =
      '<i class="fa fa-edit" aria-hidden="true" style="cursor: pointer;"></i>';
    element.innerHTML = template;
    element.addEventListener("click", () => {
      sessionStorage.removeItem("broadcastData");
      sessionStorage.setItem("broadcastData", broadcastData);
      let allowAction = this.checkRoleForAction(this.botConfigId);
      if (allowAction) {
        this.router.navigate(["utility/addbroadcast"]);
      } else {
        this.toasterService.error(
          "You are not authorized to edit broadcast for this BOT!"
        );
      }
    });
    return element;
  }
  OnCreateNewBroadcast() {
    let allowAction = this.checkRoleForAction(this.botConfigId);
    if (allowAction) {
      sessionStorage.removeItem("broadcastData");
      this.router.navigate(["utility/addbroadcast"]);
    } else {
      this.toasterService.error(
        "You are not authorized to create broadcast for this BOT!"
      );
      console.log("You are not authorized to create broadcast for this BOT!");
    }
  }
  ngOnDestroy(): void {
    this._subscriptions.unsubscribe();
  }
  setBotInfoSession() {
    let botInfo = {
      botConfigId: this.botConfigId,
      displayName: this.selectedBot,
    };
    let botData = JSON.stringify(botInfo);
    sessionStorage.removeItem("broadcastBotInfo");
    sessionStorage.setItem("broadcastBotInfo", botData);
  }
  checkRoleForAction(selectedbotConfigId: number) {
    if (selectedbotConfigId <= 0) {
      this.broadcastBotInfo = JSON.parse(
        sessionStorage.getItem("broadcastBotInfo")
      );
      selectedbotConfigId = this.broadcastBotInfo.botConfigId;
    }
    this.userRoleDetails = JSON.parse(sessionStorage.getItem("userBotRoles"));
    let botConfigId = this.userRoleDetails.filter(
      (x) =>
        (x.botConfigId == selectedbotConfigId || x.botConfigId == 0) &&
        (x.role.toLowerCase() == "chatbot admin" ||
          x.role.toLowerCase() == "chatbotadmin" ||
          x.role.toLowerCase() == "super admin" ||
          x.role.toLowerCase() == "superadmin")
    );
    if (botConfigId && botConfigId.length > 0) return true;
    else return false;
  }
}
